import React from 'react'

const About = () => {
  return (
    <div className='flex text-gray-500 h-full justify-center'>
      <div className="h1 text-6xl mb-2">Github Finder</div>
    </div>
  )
}

export default About